import { useMutation, useQuery } from '@tanstack/react-query'
import React, { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {
  createGraph,
  getGraphById,
  prefillGraphs,
  updateGraph,
} from '../../api/graphApi'
import Breadcrum from '../../components/breadcrum'
import { FaArrowLeft } from 'react-icons/fa'
// import { validateCin } from '../api/dashboardApi'

const AddGraph = () => {
  const location = useLocation()
  const { graphId, edit } = location.state || {}

  const isEdit = edit || false

  const [imagePreview, setImagePreview] = useState(null)
  const [hideInfo, setHideInfo] = useState(false)
  const [hideGraph, setHideGraph] = useState(false)
  const [hideFundRaise, setHideFundRaise] = useState(false)
  const [Isworld, setIsworld] = useState(false)

  const navigate = useNavigate()

  // const [cinValidation, setCinValidation] = useState({
  //   isValidating: false,
  //   isValid: null,
  //   companyName: '',
  //   error: '',
  // })

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      companyName: '',
      netProfitLoss: '',
      yearIncorporation: '',
      industry: '',
      grossRevenue: '',
      ebitda: '',
      brandName: '',
      cin: '',
      cinWorld: '',
      grossYear: '',
      grossRevenueData: '',
      grossExpensesData: '',
      fundRaiseYear: '',
      fundRaiseAmount: '',
      fundRaiseRound: '',
      otherIncome: '',
      hideInfoBox: false,
      hideGraph: false,
      hideFundRaise: false,
    },
  })

  const imageFile = watch('image')

  // Updated React component validation function
  // const validateCIN = async (cinNumber) => {
  //   if (!cinNumber || cinNumber.length !== 21) {
  //     setCinValidation({
  //       isValidating: false,
  //       isValid: false,
  //       companyName: '',
  //       error: 'Invalid CIN format',
  //     })
  //     return
  //   }

  //   setCinValidation((prev) => ({ ...prev, isValidating: true }))

  //   try {
  //     setCinValidation((prev) => ({
  //       ...prev,
  //       isValidating: true,
  //     }))

  //     const res = await validateCin(cinNumber)
  //     console.log('Validation result:', res)

  //     if (res?.company) {
  //       setCinValidation({
  //         isValidating: false,
  //         isValid: true,
  //         companyName: res.company,
  //         error: '',
  //       })
  //     } else {
  //       setCinValidation({
  //         isValidating: false,
  //         isValid: false,
  //         companyName: '',
  //         error: res?.error || 'CIN not found',
  //       })
  //     }
  //   } catch (error) {
  //     console.error('CIN validation error:', error)
  //     setCinValidation({
  //       isValidating: false,
  //       isValid: false,
  //       companyName: '',
  //       error: error?.response?.data?.error || 'Error validating CIN',
  //     })
  //   }
  // }

  // 3. Add this useEffect to watch for CIN changes
  // useEffect(() => {
  //   const cinValue = watch('cin')
  //   if (cinValue && cinValue.length === 21) {
  //     const debounceTimer = setTimeout(() => {
  //       validateCIN(cinValue)
  //     }, 500) // 500ms delay to avoid too many API calls

  //     return () => clearTimeout(debounceTimer)
  //   } else if (cinValue && cinValue.length > 0) {
  //     setCinValidation({
  //       isValidating: false,
  //       isValid: null,
  //       companyName: '',
  //       error: '',
  //     })
  //   }
  // }, [watch('cin')])

  // Fetch deal data for editing
  const { data: graphData, isLoading } = useQuery({
    queryKey: ['graph', graphId],
    queryFn: () => getGraphById(graphId),
    enabled: isEdit && !!graphId,
    onSuccess: (data) => {
      console.log('Query success handler triggered with data:', data)
      populateForm(data)
    },
    onError: (error) => {
      toast.error('Failed to load data')
      console.error('Error loading Deals :', error)
      navigate('/dealdashboard/add/graph')
    },
  })
  // Separate function to handle form population
  const populateForm = useCallback(
    (data) => {
      if (!data) {
        toast.error('No data available to populate form')
        return
      }

      console.log('Populating form with data:', data)

      // Set each form field with proper fallbacks

      setValue('netProfitLoss', data.netProfitLoss || '')
      setValue('companyName', data.companyName || '')
      setValue('brandName', data.brandName || '')
      setValue('cin', data.cin || '')
      setValue('cinWorld', data.cin || '')
      setValue('yearIncorporation', data.yearIncorporation || '')
      setValue('industry', data.industry || '')
      setValue('grossRevenue', data.grossRevenue || '')
      setValue('ebitda', data.ebitda || '')
      setValue('otherIncome', data.otherIncome || '')
      setValue('grossYear', data.grossYear || '')
      setValue('grossRevenueData', data.grossRevenueData || '')
      setValue('grossExpensesData', data.grossExpensesData || '')
      setValue('fundRaiseYear', data.fundRaiseYear || '')
      setValue('fundRaiseAmount', data.fundRaiseAmount || '')
      setValue('fundRaiseRound', data.fundRaiseRound || '')
      setValue('hideInfoBox', data.hideInfoBox || false)
      setValue('hideGraph', data.hideGraph || false)
      setValue('hideFundRaise', data.hideFundRaise || false)

      setHideGraph(data.hideGraph || false)
      setHideFundRaise(data.hideFundRaise || false)
      setHideInfo(data.hideInfoBox || false)
      if (data.imageUrl) {
        setImagePreview(data.imageUrl)
      }

      console.log('Form populated with values')
    },
    [setValue]
  )

  // Populate form when data is available
  useEffect(() => {
    if (isEdit && graphData) {
      console.log('graphData updated in useEffect:', graphData)
      populateForm(graphData)
    }
  }, [graphData, isEdit])

  // Handle image preview
  useEffect(() => {
    if (imageFile && imageFile[0]) {
      const previewUrl = URL.createObjectURL(imageFile[0])
      setImagePreview(previewUrl)
      return () => URL.revokeObjectURL(previewUrl)
    }
  }, [imageFile])

  // Sync hideInfo checkbox with form
  useEffect(() => {
    setValue('hideInfoBox', hideInfo)
  }, [hideInfo, setValue])

  useEffect(() => {
    setValue('hideGraph', hideGraph)
  }, [hideGraph, setValue])

  useEffect(() => {
    setValue('hideFundRaise', hideFundRaise)
  }, [hideFundRaise, setValue])

  // Create deal mutation
  const createMutation = useMutation({
    mutationFn: (data) => createGraph(data),
    onSuccess: () => {
      toast.success(`Graph added successfully!`)
      reset()
      setImagePreview(null)
      navigate('/dealdashboard/graph')
    },
    onError: (error) => {
      console.error('Error creating graph:', error)
      toast.error(
        error.response?.data?.message ||
          'Error creating graph. Please try again.'
      )
    },
  })

  // Update deal mutation
  const updateMutation = useMutation({
    mutationFn: (data) => updateGraph(graphId, data),
    onSuccess: () => {
      toast.success('Graph updated successfully!')
      navigate('/dealdashboard/graph')
    },
    onError: (error) => {
      console.error('Error details:', error)
      toast.error(error.response?.data?.message || 'Failed to update Graph')
    },
  })

  // Fill the form from a company already uploaded as Excel; the admin reviews before saving.
  const [prefillQuery, setPrefillQuery] = useState('')
  const [prefillLoading, setPrefillLoading] = useState(false)
  const [prefillCandidates, setPrefillCandidates] = useState([])

  const applyPrefill = (company) => {
    const fields = [
      'companyName',
      'cin',
      'industry',
      'yearIncorporation',
      'grossRevenue',
      'ebitda',
      'netProfitLoss',
      'grossYear',
      'grossRevenueData',
      'grossExpensesData',
      'otherIncome',
      'fundRaiseRound',
      'fundRaiseYear',
      'fundRaiseAmount',
    ]
    fields.forEach((f) =>
      setValue(f, company[f] ?? '', { shouldValidate: f === 'cin' })
    )
    if (!watch('brandName') && company.brandName) {
      setValue('brandName', company.brandName)
    }
    toast.success(
      company.fundRaiseYear
        ? `Filled from ${company.companyName}`
        : `Filled from ${company.companyName} (no funding rounds in its Excel)`
    )
  }

  const runPrefill = async (query) => {
    const q = (query || '').trim()
    if (!q) {
      toast.error('Enter a company name, brand or CIN')
      return
    }
    setPrefillLoading(true)
    setPrefillCandidates([])
    try {
      const [result] = await prefillGraphs([q])
      if (result?.status === 'found') {
        applyPrefill(result.company)
      } else if (result?.status === 'ambiguous') {
        setPrefillCandidates(result.candidates || [])
      } else {
        toast.error(`"${q}" is not in DSJ data; fill the form by hand`)
      }
    } catch (error) {
      toast.error(error.response?.data || 'Could not load DSJ data')
    } finally {
      setPrefillLoading(false)
    }
  }

  const handleImageChange = useCallback(
    (e, fieldName) => {
      const files = e.target.files
      if (files && files.length > 0) {
        setValue(fieldName, files)
      }
    },
    [setValue]
  )

  const onSubmit = async (data) => {
    console.log('Form submitted with data:', data)

    // if (!cinValidation.isValid) {
    //   setError('cin', {
    //     type: 'manual',
    //     message: 'Please enter a correct CIN number',
    //   })
    //   toast.error('Please enter a correct CIN number')
    //   return
    // }

    if (isEdit && graphId) {
      updateMutation.mutate(data)
    } else {
      createMutation.mutate(data)
    }
  }

  if (isEdit && isLoading) {
    return (
      <div className="max-w-8xl text-center mx-auto px-4 py-6">
        <p className="text-gray-600">Loading Graph data...</p>
      </div>
    )
  }

  return (
    <>
      <Breadcrum
        heading="Deals"
        subheading={isEdit ? 'Edit Graph' : 'Add Graph'}
      />

      <button
        type="button"
        onClick={() => navigate(-1)}
        className="flex justify-center items-center bg-gray-500 p-2 text-white rounded sticky -top-[15px]"
      >
        <FaArrowLeft />
        &nbsp; Back
      </button>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="max-w-8xl text-left mx-auto px-4 py-6">
          {/* Fill from DSJ data */}
          <div className="bg-orange-50 border border-orange-200 p-4 rounded-xl mb-6">
            <div className="flex flex-wrap justify-between items-center gap-2 mb-2">
              <h2 className="font-semibold text-gray-800">
                Fill from DSJ data
              </h2>
              <Link
                to="/dealdashboard/add/graph-bulk"
                className="text-sm text-[#ff7010] underline"
              >
                Add several companies at once
              </Link>
            </div>
            <p className="text-sm text-gray-600 mb-3">
              Company name, brand or CIN of a company whose Excel is uploaded.
              Every field below is filled from it; check them, add the brand
              logo, then save.
            </p>
            <div className="flex flex-wrap gap-2">
              <input
                type="text"
                value={prefillQuery}
                onChange={(e) => setPrefillQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault()
                    runPrefill(prefillQuery)
                  }
                }}
                placeholder="e.g. SkinInspired or U24246RJ2022PTC080216"
                className="border border-gray-300 rounded-lg p-2 flex-1 min-w-[220px] focus:outline-none focus:border-orange-500"
              />
              <button
                type="button"
                onClick={() => runPrefill(prefillQuery)}
                disabled={prefillLoading}
                className="bg-[#ff7010] text-white px-4 py-2 rounded-lg disabled:opacity-60"
              >
                {prefillLoading ? 'Loading…' : 'Fill form'}
              </button>
            </div>
            {prefillCandidates.length > 0 && (
              <div className="mt-3">
                <p className="text-sm text-gray-700 mb-2">
                  More than one company matches. Pick one:
                </p>
                <div className="flex flex-wrap gap-2">
                  {prefillCandidates.map((c) => (
                    <button
                      type="button"
                      key={c.cin || c.companyName}
                      onClick={() => runPrefill(c.cin || c.companyName)}
                      className="text-sm bg-white border border-gray-300 rounded-lg px-3 py-1 hover:border-orange-500"
                    >
                      {c.brandName ? `${c.brandName} — ` : ''}
                      {c.companyName}
                      {c.cin ? ` (${c.cin})` : ''}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-4">
            {/* for world */}
            <div className="flex items-center w-fit bg-red-500/20 p-2 rounded col-span-2 gap-2">
              <input
                type="checkbox"
                id="isworld"
                checked={Isworld}
                onChange={() => setIsworld(!Isworld)}
              />
              <label htmlFor="isworld" className="cursor-pointer text-gray-700">
                Is World Article ?
              </label>
            </div>

            {/* Brand Name */}
            <div className="bg-white p-6 rounded-xl shadow">
              <h2 className="font-semibold text-gray-800 mb-2">
                Brand Name <span className="text-red-500">*</span>
              </h2>
              <input
                type="text"
                placeholder="Enter brand name"
                {...register('brandName', {
                  required: 'Brand name is required',
                })}
                className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                  errors.brandName
                    ? 'border-red-500 focus:border-red-500'
                    : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                }`}
              />
              {errors.brandName && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.brandName.message}
                </p>
              )}
            </div>

            {/* CIN Number */}
            {Isworld === false && (
              <div className="bg-white p-6 rounded-xl shadow">
                <h2 className="font-semibold text-gray-800 mb-2">
                  Company CIN Number <span className="text-red-500">*</span>
                </h2>
                <input
                  type="text"
                  placeholder="Enter CIN number"
                  {...register('cin', {
                    required: 'CIN number is required',
                    pattern: {
                      value:
                        /^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,
                      message: 'Please enter a valid CIN number format',
                    },
                  })}
                  className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                    errors.cin
                      ? 'border-red-500 focus:border-red-500'
                      : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                  }`}
                />
                {errors.cin && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.cin.message}
                  </p>
                )}

                {/* CIN Validation Status */}
                {/* {cinValidation.isValidating && (
                <div className="flex items-center mt-2 text-blue-600">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
                  <span className="text-sm">Validating CIN...</span>
                </div>
              )}

              {cinValidation.isValid === true && (
                <div className="flex items-center mt-2 text-green-600">
                  <svg
                    className="h-4 w-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span className="text-sm font-medium">
                    {cinValidation.companyName}
                  </span>
                </div>
              )}

              {cinValidation.isValid === false && (
                <div className="flex items-center mt-2 text-red-600">
                  <svg
                    className="h-4 w-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                  <span className="text-sm">{cinValidation.error}</span>
                </div>
              )} */}
              </div>
            )}

            {Isworld === true && (
              <div className="bg-white p-6 rounded-xl shadow">
                <h2 className="font-semibold text-gray-800 mb-2">
                  Company Number <span className="text-red-500">*</span>
                </h2>
                <input
                  type="text"
                  placeholder="Enter company number"
                  {...register('cinWorld', {
                    required: 'company number is required',
                  })}
                  className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                    errors.cinWorld
                      ? 'border-red-500 focus:border-red-500'
                      : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                  }`}
                />
                {errors.cinWorld && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.cinWorld.message}
                  </p>
                )}
              </div>
            )}

            {/* hideInfoBox */}
            <div className="flex items-center w-fit col-span-2 gap-2">
              <input
                type="checkbox"
                id="hideInfo"
                checked={hideInfo}
                onChange={() => setHideInfo(!hideInfo)}
              />
              <label
                htmlFor="hideInfo"
                className="cursor-pointer text-gray-700"
              >
                Hide Information Box
              </label>
            </div>
            {/* for company profile  */}
            {!hideInfo && (
              <>
                {/* Company Name */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    Company Name <span className="text-red-500">*</span>
                  </h2>
                  <input
                    type="text"
                    placeholder="Enter company name"
                    {...register('companyName', {
                      required: 'Company name is required',
                    })}
                    className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                      errors.companyName
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                    }`}
                  />
                  {errors.companyName && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.companyName.message}
                    </p>
                  )}
                </div>

                {/* Year Incorporation */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    Year Incorporation <span className="text-red-500">*</span>
                  </h2>
                  <input
                    type="number"
                    placeholder="Enter year"
                    {...register('yearIncorporation', {
                      required: 'Year of incorporation is required',
                      min: {
                        value: 1800,
                        message: 'Year must be after 1800',
                      },
                      max: {
                        value: new Date().getFullYear(),
                        message: 'Year cannot be in the future',
                      },
                    })}
                    className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                      errors.yearIncorporation
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                    }`}
                  />
                  {errors.yearIncorporation && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.yearIncorporation.message}
                    </p>
                  )}
                </div>

                {/* Industry */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    Industry <span className="text-red-500">*</span>
                  </h2>
                  <input
                    type="text"
                    placeholder="Enter industry"
                    {...register('industry', {
                      required: 'Industry is required',
                    })}
                    className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                      errors.industry
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                    }`}
                  />
                  {errors.industry && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.industry.message}
                    </p>
                  )}
                </div>

                {/* Gross Revenue */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    Gross Revenue <span className="text-red-500">*</span>
                  </h2>
                  <input
                    type="text"
                    placeholder="Enter revenue"
                    {...register('grossRevenue', {
                      required: 'Gross revenue is required',
                    })}
                    className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                      errors.grossRevenue
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                    }`}
                  />
                  {errors.grossRevenue && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.grossRevenue.message}
                    </p>
                  )}
                </div>

                {/* EBITDA */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    EBITDA<span className="text-red-500">*</span>
                    <span className="text-gray-500">
                      (Add + or - to denote Profit/Loss)
                    </span>
                  </h2>
                  <input
                    type="text"
                    placeholder="Enter EBITDA (e.g., +50000 or -25000)"
                    {...register('ebitda', {
                      required: 'Ebitda is required',
                    })}
                    className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                      errors.ebitda
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                    }`}
                  />
                  {errors.ebitda && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.ebitda.message}
                    </p>
                  )}
                </div>

                {/* Net Profit */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    Net Profit / (Loss)<span className="text-red-500">*</span>
                    <span className="text-gray-500">
                      (Add + or - to denote Profit/Loss)
                    </span>
                  </h2>
                  <input
                    type="text"
                    placeholder="Enter net profit or loss (e.g., +30000 or -15000)"
                    {...register('netProfitLoss', {
                      required: 'Net profit loss is required',
                    })}
                    className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                      errors.netProfitLoss
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                    }`}
                  />
                  {errors.netProfitLoss && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.netProfitLoss.message}
                    </p>
                  )}
                </div>

                {/* company Logo */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    Company Logo{' '}
                    {!isEdit && <span className="text-red-500">*</span>}
                  </h2>
                  {imagePreview && (
                    <img
                      src={imagePreview}
                      alt="Brand Logo Preview"
                      className="mt-4 max-h-64 object-cover rounded-lg border border-gray-200"
                    />
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageChange(e, 'image')}
                    {...register('image', {
                      required: isEdit ? false : 'Image is required',
                    })}
                    className="mt-3 block w-full text-sm text-gray-700 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-orange-50 file:text-orange-600 hover:file:bg-orange-100"
                  />
                  {errors.image && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.image.message}
                    </p>
                  )}
                </div>
              </>
            )}

            {/* for add graph */}
            <div className="flex items-center gap-2 col-span-2 mt-4">
              <input
                type="checkbox"
                id="hideGraph"
                checked={hideGraph}
                onChange={() => setHideGraph(!hideGraph)}
              />
              <label
                htmlFor="hideGraph"
                className="cursor-pointer text-gray-700"
              >
                Hide Graph
              </label>
            </div>

            {/* for graph */}
            {!hideGraph && (
              <>
                {/* Gross Year */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    Financial Year <span className="text-red-500">*</span>
                  </h2>
                  <input
                    type="text"
                    placeholder="Enter comma seperated value (e.g., 2023-24, 2024-25, 2025-26)"
                    {...register('grossYear', {
                      required: 'Gross Year is required',
                    })}
                    className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                      errors.grossYear
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                    }`}
                  />
                  {errors.grossYear && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.grossYear.message}
                    </p>
                  )}
                </div>

                {/* Gross Revenue */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    Gross Revenue data <span className="text-red-500">*</span>
                  </h2>
                  <input
                    type="text"
                    placeholder="Enter comma seperated value (e.g., 50000, 75000, 100000)"
                    {...register('grossRevenueData', {
                      required: 'Gross revenue data is required',
                    })}
                    className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                      errors.grossRevenueData
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                    }`}
                  />
                  {errors.grossRevenueData && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.grossRevenueData.message}
                    </p>
                  )}
                </div>

                {/* Gross Expenses */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    Gross Expenses data <span className="text-red-500">*</span>
                  </h2>
                  <input
                    type="text"
                    placeholder="Enter comma seperated value (e.g., 50000, 75000, 100000)"
                    {...register('grossExpensesData', {
                      required: 'Gross revenue data is required',
                    })}
                    className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                      errors.grossExpensesData
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                    }`}
                  />
                  {errors.grossExpensesData && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.grossExpensesData.message}
                    </p>
                  )}
                </div>

                {/* other income */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    Other Income data <span className="text-red-500">*</span>
                  </h2>
                  <input
                    type="text"
                    placeholder="Enter comma seperated value (e.g., 50000, 75000, 100000)"
                    {...register('otherIncome', {
                      required: 'other income data is required',
                    })}
                    className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                      errors.otherIncome
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                    }`}
                  />
                  {errors.otherIncome && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.otherIncome.message}
                    </p>
                  )}
                </div>
              </>
            )}

            {/* add Fund Raise graph */}
            <div className="flex items-center gap-2 col-span-2 mt-4">
              <input
                type="checkbox"
                id="hideFundRaise"
                checked={hideFundRaise}
                onChange={() => setHideFundRaise(!hideFundRaise)}
              />
              <label
                htmlFor="hideFundRaise"
                className="cursor-pointer text-gray-700"
              >
                Hide Fund-Raise
              </label>
            </div>

            {/* for fund Raise graph */}
            {!hideFundRaise && (
              <>
                {/* Gross Year */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    Fund Raise Round
                    <span className="text-red-500">*</span>
                  </h2>
                  <input
                    type="text"
                    placeholder="Enter comma seperated value (e.g., seed, preseed, growth, ma)"
                    {...register('fundRaiseRound', {
                      required: 'Round is required',
                    })}
                    className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                      errors.fundRaiseRound
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                    }`}
                  />
                  {errors.fundRaiseRound && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.fundRaiseRound.message}
                    </p>
                  )}
                </div>

                {/* Fund raise year */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    Fund Raise Financial Year
                    <span className="text-red-500">*</span>
                  </h2>
                  <input
                    type="text"
                    placeholder="Enter comma seperated value (e.g., 2023-24, 2024-25, 2025-26)"
                    {...register('fundRaiseYear', {
                      required: 'Amount is required is required',
                    })}
                    className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                      errors.fundRaiseYear
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                    }`}
                  />
                  {errors.fundRaiseYear && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.fundRaiseYear.message}
                    </p>
                  )}
                </div>

                {/* fund raise amount */}
                <div className="bg-white p-6 rounded-xl shadow">
                  <h2 className="font-semibold text-gray-800 mb-2">
                    Fund Raise Amount
                    <span className="text-red-500">*</span>
                  </h2>
                  <input
                    type="text"
                    placeholder="Enter comma seperated value (e.g., 50000, 75000, 100000)"
                    {...register('fundRaiseAmount', {
                      required: 'Amount is required',
                    })}
                    className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                      errors.fundRaiseAmount
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                    }`}
                  />
                  {errors.fundRaiseAmount && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.fundRaiseAmount.message}
                    </p>
                  )}
                </div>
              </>
            )}
          </div>

          {/* Submit Button */}
          <div className="mt-8 text-center">
            <button
              type="submit"
              disabled={
                isSubmitting ||
                createMutation.isPending ||
                updateMutation.isPending
              }
              className="bg-orange-500 hover:bg-orange-600 disabled:bg-orange-300 disabled:cursor-not-allowed disabled:opacity-50 text-white text-lg font-medium px-8 py-3 rounded-lg shadow-md transition-all"
            >
              {isSubmitting ||
              createMutation.isPending ||
              updateMutation.isPending
                ? 'Processing...'
                : isEdit
                ? 'Update Graph'
                : 'Add Graph'}
            </button>
          </div>
        </div>
      </form>
    </>
  )
}

export default AddGraph
